module.exports = __webpack_public_path__ + "assets/img/6adfadf4902b16f4b4cab0a0f7bd0051.png";